import * as moment from 'moment';
// eslint-disable-next-line
export const emailReg = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;

export const emailRules = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;

const env = process.env;
const moduleName = env['MODULE_CMP'];

export const filterTargerProject = (data, type) => {
    if (!type.length) {
        return data;
    }
    var o = {
        classfy: {},
        daysData: data.daysData,
        lastDaysData: data.lastDaysData
    };
    for (let item in data.classfy) {
        type.forEach(ele => {
            if (item === ele) {
                o.classfy[item] = data.classfy[item];
            }
        });
    }
    return o;
};

export function clone(object) {
    return JSON.parse(JSON.stringify(object));
}

export const renderaccountName = (data) => {
    // eslint-disable-next-line
    let {pinterest_account_name, company_name, proxy, product_name, delivery_type, reddit_account_name} = data;
    let mediaName = data.media_name;
    let text = '';
    switch (mediaName) {
        case 'pinterest':
            // eslint-disable-next-line
            text = pinterest_account_name;
            break;
        case 'asm':
        case 'snapchat':
            // eslint-disable-next-line
            // text = `${company_name}-${proxy}-${product_name}-${delivery_type}`;
            text = '开户成功后可查看';
            break;
        case 'reddit':
            // eslint-disable-next-line
            text = reddit_account_name;
            break;
        default:
            text = data.account_name;
            break;
    }
    return text;
};

// 判断是否有访问权限
// list 是后台返回的有权限访问的uri列表
// id 是当前 uri 对应的 id 值
export function hasPermission(list, uri) {
    if (!uri || !list.length) {
        return false;
    };
    return list.some(item => item.uri === uri);
}

// 求两数组交集
export function filterArr(arr1, arr2) {
    let ids = arr2 && arr2.length ? arr2.map(item => item.uri) : [];
    let res = [];
    let pathArr = makeFullRoute(arr1);
    pathArr.forEach(route => {
        const tem = {...route};
        if (tem.fullPath) {
            if (ids.indexOf(tem.fullPath) > -1) {
                if (tem.children) {
                    tem.children = filterArr(tem.children, arr2);
                }
                res.push(tem);
            }
        } else {
            if (tem.children) {
                tem.children = filterArr(tem.children, arr2);
                tem.children && tem.children.length && res.push(tem);
            }
        }
    });
    return res;
}

function makeFullRoute(arr) {
    let res = [];
    arr.forEach(item => {
        if (item.path) {
            if (item.children && item.children.length) {
                item.children = makeFullRoute(item.children);
                res.push(item);
            }
            res.push({
                ...item,
                fullPath: `/${moduleName}${item.path}`
            });
        } else {
            if (item.children && item.children.length) {
                item.children = makeFullRoute(item.children);
                res.push(item);
            }
        }
    });
    return res;
}

export const firstUpperCase = ([first, ...rest]) => first.toUpperCase() + rest.join('');

// js深拷贝
export function deepCopy(obj) {
    if (obj === null || obj === undefined || typeof obj !== 'object') {
        return obj;
    }
    if (obj.constructor === Array) {
        if (obj.length === 0) {
            return obj;
        } else {
            let newArr = [];
            for (let i = 0; i < obj.length; i++) {
                newArr.push(deepCopy(obj[i]));
            }
            return newArr;
        }
    }
    let newObj = {};
    for (let i in obj) {
        newObj[i] = deepCopy(obj[i]);
    }
    return newObj;
};

// 文件下载
export function downloadFile(data, fileName, type) {
    const url = window.URL.createObjectURL(new Blob([data], {type: type}));
    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

const zwReg = /^[\u4e00-\u9fa5]$/;
const compare = (a, b, key) => {
    for (let i = 0, len = a[key].length; i < len; i++) {
        let x = a[key][i];
        let y = b[key][i];
        // 都是中文按照拼音a-z排序
        if (zwReg.test(x) && zwReg.test(y)) {
            return x.localeCompare(y);
        }
        if (a[key][i] < b[key][i]) {
            return -1;
        }
        if (a[key][i] > b[key][i]) {
            return 1;
        }
    }
    return 0;
};

// 静态表格排序方法
export const sortTableData = (data, key, order) => {
    if (data && data.length && order) {
        data.sort((a, b) => {
            if (!isNaN(a[key])) {
                return order === 'ascending' ? a[key] - b[key] : b[key] - a[key];
            } else {
                // return order === 'ascending'
                //     ? a[key].localeCompare(b[key])
                //     : b[key].localeCompare(a[key]);
                return order === 'ascending'
                    ? compare(a, b, key)
                    : compare(b, a, key);
            }
        });
        return data;
    }
    return data;
};

export function flatten(arr) {
    return arr.reduce((res, next) => {
        return res.concat(Array.isArray(next) ? flatten(next) : next);
    }, []);
}

// 对象数组去重
export const uniqObjArr = (arr, key) => {
    let obj = {};
    if (arr && arr.length) {
        return arr.reduce((pre, next) => {
            if (!obj[next[key]]) {
                pre.push(next);
                obj[next[key]] = true;
            }
            return pre;
        }, []);
    }
    return arr;
};

// 转化媒体名称
export const renderMediaName = (name) => {
    if (!name) {
        return null;
    }
    let text = name.toLowerCase();
    // let target = '';
    let target = [];
    let textArr = text.split(',');
    textArr.forEach(text => {
        switch (text) {
            case 'snapchat':
                // target = 'Snapchat';
                target.push('Snapchat');
                break;
            case 'pinterest':
                // target = 'Pinterest';
                target.push('Pinterest');
                break;
            case 'reddit':
                // target = 'Reddit';
                target.push('Reddit');
                break;
            case 'asm':
                // target = 'ASA';
                target.push('ASA');
                break;
            case 'asa':
                // target = 'ASA';
                target.push('ASA');
                break;
            case 'facebook':
                // target = 'Facebook';
                target.push('Facebook');
                break;
            default:
                // target = name;
                target.push(name);
                break;
        }
    });
    return target.join(',');
};

// 计算字符长度，中文=2，英文=1
export const gblen = (str) => {
    let len = 0;
    for (let i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) > 127 || str.charCodeAt(i) === 94) {
            len += 2;
        } else {
            len++;
        }
    }
    return len;
};

// 截取字符串
export function getTrueStr(str, num) {
    if (gblen(str) > num) {
        return str.substring(0, num).replace(/,$/gi, '') + '...';
    }
    return str;
    // return gblen(str) > num ? str.subString(0, num) : str;
}

export const getTrueValue = (value, type = 'value') => {
    if (Array.isArray(value)) {
        if (value && value.length) {
            if (typeof (value[0]) === 'string' || typeof value[0] === 'number') {
                return value;
            } else {
                return value.map(item => {
                    return type === 'value' ? item.value : item.label;
                });
            }
        } else {
            return undefined;
        }
        // return value && value.length ? value : undefined;
    } else {
        return value || undefined;
    }
};

export const datePickerShortcuts = [{
    text: '今天',
    onClick(picker) {
        let start = moment().startOf('day').format('YYYY-MM-DD');
        let end = moment().endOf('day').format('YYYY-MM-DD');
        picker.$emit('pick', [start, end]);
    }
}, {
    text: '昨天',
    onClick(picker) {
        let start = moment().startOf('day').add(-1, 'days').format('YYYY-MM-DD');
        let end = moment().endOf('day').add(-1, 'days').format('YYYY-MM-DD');
        picker.$emit('pick', [start, end]);
    }
}, {
    text: '过去7天',
    onClick(picker) {
        let start = moment().startOf('day').add(-7, 'days').format('YYYY-MM-DD');
        let end = moment().endOf('day').add(-1, 'days').format('YYYY-MM-DD');
        picker.$emit('pick', [start, end]);
    }
}, {
    text: '过去14天',
    onClick(picker) {
        let start = moment().startOf('day').add(-14, 'days').format('YYYY-MM-DD');
        let end = moment().endOf('day').add(-1, 'days').format('YYYY-MM-DD');
        picker.$emit('pick', [start, end]);
    }
}, {
    text: '过去30天',
    onClick(picker) {
        let start = moment().startOf('day').add(-30, 'days').format('YYYY-MM-DD');
        let end = moment().endOf('day').add(-1, 'days').format('YYYY-MM-DD');
        picker.$emit('pick', [start, end]);
    }
}, {
    text: '本周',
    onClick(picker) {
        let start = moment().startOf('week').format('YYYY-MM-DD');
        // let end = moment().endOf('week').format('YYYY-MM-DD');
        let end = moment().endOf('day').format('YYYY-MM-DD');
        picker.$emit('pick', [start, end]);
    }
}, {
    text: '上周',
    onClick(picker) {
        let start = moment().week(moment().week() - 1).startOf('week').format('YYYY-MM-DD');
        let end = moment().week(moment().week() - 1).endOf('week').format('YYYY-MM-DD');
        picker.$emit('pick', [start, end]);
    }
}, {
    text: '本月',
    onClick(picker) {
        let start = moment().startOf('month').format('YYYY-MM-DD');
        // let end = moment().endOf('month').format('YYYY-MM-DD');
        let end = moment().endOf('day').format('YYYY-MM-DD');
        picker.$emit('pick', [start, end]);
    }
}, {
    text: '上个月',
    onClick(picker) {
        let start = moment().month(moment().month() - 1).startOf('month').format('YYYY-MM-DD');
        let end = moment().month(moment().month() - 1).endOf('month').format('YYYY-MM-DD');
        picker.$emit('pick', [start, end]);
    }
}];

export const financeDatePickerShortcuts = [{
    text: '今天',
    onClick(picker) {
        let start = moment().startOf('day').format('YYYY-MM-DD');
        let end = moment().endOf('day').format('YYYY-MM-DD');
        picker.$emit('pick', [start, end]);
    }
}, {
    text: '昨天',
    onClick(picker) {
        let start = moment().startOf('day').add(-1, 'days').format('YYYY-MM-DD');
        let end = moment().endOf('day').add(-1, 'days').format('YYYY-MM-DD');
        picker.$emit('pick', [start, end]);
    }
}, {
    text: '过去7天',
    onClick(picker) {
        let start = moment().startOf('day').add(-7, 'days').format('YYYY-MM-DD');
        let end = moment().endOf('day').add(-1, 'days').format('YYYY-MM-DD');
        picker.$emit('pick', [start, end]);
    }
}, {
    text: '过去30天',
    onClick(picker) {
        let start = moment().startOf('day').add(-30, 'days').format('YYYY-MM-DD');
        let end = moment().endOf('day').add(-1, 'days').format('YYYY-MM-DD');
        picker.$emit('pick', [start, end]);
    }
}, {
    text: '本季',
    onClick(picker) {
        let start = moment().startOf('quarter').format('YYYY-MM-DD');
        let end = moment().endOf('day').format('YYYY-MM-DD');
        picker.$emit('pick', [start, end]);
    }
}, {
    text: '上季',
    onClick(picker) {
        let start = moment().quarter(moment().quarter() - 1).startOf('quarter').format('YYYY-MM-DD');
        let end = moment().quarter(moment().quarter() - 1).endOf('quarter').format('YYYY-MM-DD');
        picker.$emit('pick', [start, end]);
    }
}, {
    text: '全年',
    onClick(picker) {
        let start = moment().startOf('year').format('YYYY-MM-DD');
        // let end = moment().endOf('month').format('YYYY-MM-DD');
        let end = moment().endOf('day').format('YYYY-MM-DD');
        picker.$emit('pick', [start, end]);
    }
}];

/**
 * 千位分隔数
 * @param {number | string}
 * @return {string}
 * */
export const thousandSeparator = function (n) {
    if (!n || n === 'inf' || n === 'inf%') return n;
    let str = n + '';
    let suffix = '';
    let prefix = '';
    if (str[str.length - 1] === '%') {
        suffix = '%';
        str = str.substring(0, str.length - 1);
    }
    if (str[0] === '$') {
        prefix = '$';
        str = str.substring(1, str.length);
    }

    const arr = str.split('.');
    const res = arr[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (arr[1]) {
        return prefix + res + '.' + arr[1] + suffix;
    }
    return prefix + res + suffix;
};

export const getProductTypeLabel = (value, list) => {
    if (!list || list.length === 0) {
        return value;
    }
    const select = list.find(i => i.value === value);
    return select ? select.label : value;
};
export const getProductTypeValue = (label, list) => {
    if (!list || list.length === 0) {
        return label;
    }
    const select = list.find(i => i.label === label);
    return select ? select.value : label;
};



// WEBPACK FOOTER //
// ./src/modules/cmp/constants/utils.js